var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAgentProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 31,
    viewBox: "0 0 19 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 25.695C19 26.6236 18.6563 27.4361 17.9624 28.1261C17.2685 28.8226 16.3565 29.3513 15.233 29.7189C14.103 30.0865 12.8671 30.3573 11.519 30.5314C10.1708 30.7055 8.82922 30.7055 7.48104 30.5314C6.13287 30.3573 4.89704 30.0865 3.76696 29.7189C2.64348 29.3578 1.73148 28.8226 1.03757 28.1326C0.343652 27.4361 0 26.6236 0 25.695C0 22.4901 0.951652 19.7301 2.84835 17.4087C4.74504 15.0872 6.96556 13.9329 9.4967 13.9329C12.0278 13.9329 14.2483 15.0937 16.145 17.4087C18.0417 19.7237 19 22.4901 19 25.695ZM9.5033 12.0822C7.95687 12.0822 6.62191 11.5341 5.49843 10.4314C4.37496 9.32868 3.80661 8.02608 3.80661 6.52357C3.80661 5.02107 4.36174 3.71202 5.49183 2.60932C6.62191 1.50662 7.95687 0.958496 9.5033 0.958496C11.0497 0.958496 12.3847 1.50662 13.5082 2.60932C14.6317 3.71202 15.2 5.01462 15.2 6.51712C15.2 8.01963 14.6383 9.32868 13.5082 10.4249C12.3781 11.5212 11.0431 12.0822 9.5033 12.0822Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgentProfile);
export default __webpack_public_path__ + "static/media/agent-profile.05535a3b22caa305df88c97088d2599b.svg";
export { ForwardRef as ReactComponent };